module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAiUlEQVQokWNgoAEQZGBg+I8Dn2FgYFAi1ZB3SBjZMEFiDXmHRe4MVC4NXYKJGOdBwSwo/R5dgoWAq2DAmIGBYSaUfY+QbfgCFha4BAGyIbuR8F0k8Q5iDcEWsKF45Ig2hIEBRzSTEjvlUPo9A1oM4YodQQZIOCDzYbbPwlSOqRlXzNxlwJLQqAYASZs5c2Ka20YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/01c.png
// module id = hS0E
// module chunks = 64